import React__default from 'react';
import PropTypes from 'prop-types';
import { AnimatedRing } from './Logo.styles.js';
import { VIEW_BOX_SIZE, STROKE_WIDTH } from './Logo.contants.js';

var Ring = function Ring(_ref) {
  var _ref$animate = _ref.animate,
    animate = _ref$animate === void 0 ? false : _ref$animate,
    colour = _ref.colour,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? undefined : _ref$id,
    _ref$radius = _ref.radius,
    radius = _ref$radius === void 0 ? 200 : _ref$radius;
  var circumference = 2 * Math.PI * radius;
  var clipPathId = "logo-half-circle-clip".concat(id ? "-".concat(id) : '');
  return React__default.createElement("g", null, React__default.createElement("defs", null, React__default.createElement("clipPath", {
    id: clipPathId
  }, React__default.createElement("rect", {
    x: "0",
    y: VIEW_BOX_SIZE / 2,
    width: VIEW_BOX_SIZE,
    height: VIEW_BOX_SIZE / 2
  }))), React__default.createElement(AnimatedRing, {
    $animate: animate,
    $circumference: circumference,
    clipPath: "url(#".concat(clipPathId, ")"),
    cx: VIEW_BOX_SIZE / 2,
    cy: VIEW_BOX_SIZE / 2,
    fill: "none",
    r: radius,
    strokeDasharray: animate ? "0, ".concat(circumference) : "".concat(circumference / 2, ", ").concat(circumference / 2),
    strokeWidth: STROKE_WIDTH,
    stroke: colour
  }));
};
Ring.propTypes = {
  animate: PropTypes.bool,
  colour: PropTypes.string.isRequired,
  id: PropTypes.string,
  radius: PropTypes.number.isRequired
};
var Ring$1 = Ring;

export { Ring$1 as default };
//# sourceMappingURL=Ring.js.map
